import { createFileRoute } from "@tanstack/react-router";
import { GeographyDashboard } from "@/components/voter-file-stats/geography-dashboard";
import { useSetPageContext } from "@/hooks/use-page-context";

export const Route = createFileRoute("/_app/_/voter-file-stats/")({
	component: VoterFileStatsPage,
});

function VoterFileStatsPage() {
	useSetPageContext({
		page_key: "voter-file-stats.index",
		page_title: "Voter-File Stats",
		available_actions: [],
		current_data_summary: null,
	});

	return (
		<div className="min-h-screen bg-muted/30 p-4 md:p-6">
			<div className="mx-auto max-w-7xl space-y-4">
				<header>
					<h1 className="text-2xl font-bold tracking-tight">
						Voter-File Stats
					</h1>
					<p className="text-sm text-muted-foreground">
						Aggregate counts across the active vendor voter-file snapshot,
						scoped to your campaign's geography.
					</p>
				</header>
				<GeographyDashboard />
			</div>
		</div>
	);
}
